/** The code frame's chrome. */
export default {
  copyCode: "Copy code",
  noCode: "No code yet",
  writingCursor: "Writing cursor",
} as const;
